import gql from 'graphql-tag'

export const adminRefreshSimStatus = gql`
  mutation AdminRefreshSimStatus($input: AdminRefreshSimStatusInput!) {
    adminRefreshSimStatus(input: $input) {
      success
      simStatus
    }
  }
`
